import { defineComponent } from 'vue';
import { useRegisterTestStore } from '@/store/RegisterTestStore';
import ThemesHelper from '@/helpers/ThemesHelper';
import BaseFooter from '@/components/Shared/BaseFooter/BaseFooter.vue';
import BaseNavigation from '@/components/BaseNavigation/BaseNavigation.vue';
import TestInstructionsStepOne from '@/components/Shared/RegisterTest/TestInstructionsStepOne/TestInstructionsStepOne.vue';
import TestInstructionsStepTwo from '@/components/Shared/RegisterTest/TestInstructionsStepTwo/TestInstructionsStepTwo.vue';
import TestInstructionsStepThree from '@/components/Shared/RegisterTest/TestInstructionsStepThree/TestInstructionsStepThree.vue';
import TestInstructionsStepFour from '@/components/Shared/RegisterTest/TestInstructionsStepFour/TestInstructionsStepFour.vue';
import TestInstructionsStepFive from '@/components/Shared/RegisterTest/TestInstructionsStepFive/TestInstructionsStepFive.vue';
import TestInstructionsStepSix from '@/components/Shared/RegisterTest/TestInstructionsStepSix/TestInstructionsStepSix.vue';
import TestInstructionsStepSeven from '@/components/Shared/RegisterTest/TestInstructionsStepSeven/TestInstructionsStepSeven.vue';
import moment from 'moment';
import GoogleAnalyticsEvents from '@/helpers/GoogleAnalyticsEvents';
import LoadingScreen from '@/components/Shared/LoaderScreen/LoaderScreen.vue';
import { mapWritableState } from 'pinia';
import apiClient from '@/services/ApiClient';

export default defineComponent({
  components: {
    BaseFooter,
    BaseNavigation,
    TestInstructionsStepOne,
    TestInstructionsStepTwo,
    TestInstructionsStepThree,
    TestInstructionsStepFour,
    TestInstructionsStepFive,
    TestInstructionsStepSix,
    TestInstructionsStepSeven,
    LoadingScreen,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ['registerTestId']),
    getActiveStep(): number {
      return this.activeStep;
    },
  },
  data() {
    return {
      activeStep: 1,
      hideFooter: false,
      registerTestStore: useRegisterTestStore(),
      Loader: false,
      requestData: {},
    };
  },
  mounted() {
    this.registerTestStore.$reset();
    this.registerTestStore.canJumpNext = true;
  },
  methods: {
    nextStep() {
      let currentStep = this.activeStep;
      if (
        this.registerTestStore.canJumpNext ||
        this.registerTestStore.canJumpNext == undefined
      ) {
        this.registerTestStore.canJumpNext = true;
        this.hideFooter = true;
        currentStep++;
        GoogleAnalyticsEvents.switchStepEvent(currentStep);
        if (
          this.registerTestStore.resultTest === 'positive' &&
          this.activeStep === 6
        ) {
          this.Loader = true;
          this.hideFooter = true;
          setTimeout(() => {
            this.Loader = true;
            this.hideFooter = true;
            currentStep--;
            this.saveTest();
          }, 3000);
        } else if (this.activeStep === 7) {
          this.Loader = true;
          this.hideFooter = true;
          setTimeout(() => {
            this.Loader = true;
            this.hideFooter = true;
            this.saveTest();
          }, 1000);
        } else {
          if (this.activeStep === 5 || this.activeStep === 6) {
            this.saveTest();
          }
          const stepEl: any = this.$refs[`step-${currentStep}`];
          const numPreviousStep = currentStep - 1;
          const previousStepEl: any = this.$refs[`step-${numPreviousStep}`];
          previousStepEl.setAnimationType('setNextDismissAnimation');
          this.registerTestStore.canJumpNext = stepEl.isValidStep();

          setTimeout(() => {
            stepEl.setAnimationType('setNextShowAnimation');
          }, 150);
        }
      } else {
        const stepEl: any = this.$refs[`step-${currentStep}`];
        stepEl.errorValidation();
      }
      setTimeout(() => {
        this.activeStep = currentStep;
      }, 300);
      setTimeout(() => {
        this.hideFooter = false;
      }, 550);
    },
    previousStep() {
      let currentStep = this.activeStep;
      currentStep--;

      if (currentStep == 0) {
        this.$router.push({ name: 'HomeHiv' });
      } else {
        this.hideFooter = true;
        const stepEl: any = this.$refs[`step-${currentStep}`];
        this.registerTestStore.canJumpNext =
          currentStep == 1 ? true : stepEl.isValidStep();
        const numPreviousStep = currentStep + 1;
        const nextStepEl: any = this.$refs[`step-${numPreviousStep}`];
        nextStepEl.setAnimationType('setPreviousDismissAnimation');
        setTimeout(() => {
          const stepEl: any = this.$refs[`step-${currentStep}`];
          stepEl.setAnimationType('setPreviousShowAnimation');
        }, 150);
      }

      setTimeout(() => {
        this.activeStep = currentStep;
      }, 300);
      setTimeout(() => {
        this.hideFooter = false;
      }, 550);
    },
    saveTest() {
      const data = this.formatPostData();

      apiClient
        .post("/rapid-test/hiv", data)
        .then((res) => {
          this.requestData = res.data;
          this.registerTestId = res.data.patient.id;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          GoogleAnalyticsEvents.generateCardResult();
          if (
            (this.registerTestStore.resultTest === 'positive' &&
              this.activeStep === 7) ||
            this.activeStep === 8
          ) {
            this.$router.push({ name: 'ViewResultCardHiv' });
          }
        });
    },
    formatPostData() {
      const numberPattern = /\d+/g;
      const tmpPatient = { ...this.registerTestStore.patient };
      tmpPatient.phone = tmpPatient.phone
        ?.match(numberPattern)
        ?.join('') as string;
      tmpPatient.document = tmpPatient.document
        ?.match(numberPattern)
        ?.join('') as string;

      tmpPatient.emailMkt = true;

      const response: any = Object.assign({}, this.requestData);
      let data: any = {};

      if (this.activeStep === 5) {
        data = {
          rapidTest: {
            manufacturer: ThemesHelper.getThemeParams('manufacturer'),
            product: ThemesHelper.getThemeParams('testName'),
            date: moment().format('YYYY-MM-DD'),
          },
          patient: {
            city: tmpPatient.city,
            state: tmpPatient.state,
            age: tmpPatient.age,
            gender: tmpPatient.gender,
            sexual_orientation: tmpPatient.sexual_orientation,
            education_level: tmpPatient.education_level,
          },
        };

        if (response.patient) {
          data.patient.created = response.patient?.created;
          data.patient.rapidtest_id = response.patient?.rapidtest_id;
        }

        data.rapidTestResult = {
          code: this.registerTestStore.resultTestCode,
          result: this.registerTestStore.resultTest,
        };

        this.requestData = data;

        return this.requestData;
      } else if (this.activeStep === 6) {
        const data: any = this.requestData;

        data.patient.name = tmpPatient.name;
        data.patient.document = tmpPatient.document;
        data.patient.email = tmpPatient.email;

        this.requestData = data;

        return this.requestData;
      } else if (this.activeStep === 8) {
        const data: any = this.requestData;

        data.rapidTestParams = {
          param_id: this.registerTestStore.exposureTimeCode,
          result: this.registerTestStore.exposureTime,
        };

        this.requestData = data;

        return this.requestData;
      }

      return this.requestData;
    },
  },
});
